import { Paginated } from "../../../old/beheer/store/api/upsellApi";
import { apiRoot } from "../../../old/beheer/store/api/apiRoot";
import { UrlBuilder } from "../../../utils/UrlBuilder";
import { GridFilterItem } from "@mui/x-data-grid";
import _ from "lodash";

const productEndpoints = apiRoot.enhanceEndpoints({
  addTagTypes: ["Product"],
});

export type Product = {
  id: number;
  naam: string;
  vestiging_id: number;
  sortkey: number | null;
  apiId1: string | null;
  blocked: boolean;
  is_actief: boolean;
};

type FilterFields = "vestiging_id" | "category_id" | "product_id" | "apiId1" | "product_ids";

export const productApi = productEndpoints.injectEndpoints({
  endpoints: (builder) => ({
    fetchProducts: builder.query<
      Paginated<Product>,
      {
        gridFilterItems?: { [key in FilterFields]?: GridFilterItem };
        pagination?: {
          page: number;
          perPage: number;
        };
        include?: string[];
      }
    >({
      query: ({ gridFilterItems, pagination, include }) => {
        return {
          url: new UrlBuilder("products")
            .setPage(pagination?.page)
            .setPerPage(pagination?.perPage)
            .setFilters(_.values(gridFilterItems))
            .addInclude(include).url,
          method: "GET",
        };
      },
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Product" as const, id })),
              { type: "Product", id: "PARTIAL-LIST" },
            ]
          : [{ type: "Product", id: "PARTIAL-LIST" }],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useFetchProductsQuery } = productApi;
